import dataReducer from './data/reducer'
// import featuresReducer from './features/features.reducer'
import pagesReducer from './pages/reducer'

export default {
  data: dataReducer,
  pages: pagesReducer,
  // features: featuresReducer,
}
